import { motion } from "framer-motion";

export const Purpose = () => {
  return (
    <section
      id="purpose"
      data-testid="purpose-section"
      className="relative bg-[#2D3730] text-[#F9F8F6] py-28 md:py-44 overflow-hidden grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="font-serif-display text-[100px] md:text-[140px] lg:text-[180px] leading-[0.9] text-[#F9F8F6]/10 font-light block mb-6 md:mb-10"
        >
          03
        </motion.span>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[13px] md:text-sm uppercase tracking-[0.32em] text-[#C06E52] font-semibold mb-10 md:mb-16"
        >
          The Purpose
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2 }}
          data-testid="purpose-quote"
          className="font-serif-display font-light text-[44px] sm:text-[72px] md:text-[110px] lg:text-[140px] leading-[0.98] tracking-tight max-w-[1200px]"
        >
          Presence matters
          <br />
          more than{" "}
          <span className="italic text-[#C06E52]">presents.</span>
        </motion.h2>

        <div className="mt-20 md:mt-32 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.1 }}
            className="md:col-span-5 md:col-start-2"
          >
            <p className="text-[12px] uppercase tracking-[0.22em] text-[#8A9A86] mb-4">
              What we exist for
            </p>
            <p className="font-serif-display text-2xl md:text-[28px] leading-snug font-light text-[#F2EFEB]">
              To help fathers move from good intentions to meaningful action — not someday,
              but in the next ordinary moment with their child.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.25 }}
            className="md:col-span-5"
          >
            <p className="text-[12px] uppercase tracking-[0.22em] text-[#8A9A86] mb-4">
              What we believe
            </p>
            <p className="font-serif-display text-2xl md:text-[28px] leading-snug font-light text-[#F2EFEB]">
              That with the right tools, a father can become one of the most powerful
              influences in shaping a child&rsquo;s emotional well-being.
            </p>
          </motion.div>
        </div>

        {/* Footer underline accent */}
        <div className="mt-24 md:mt-32 flex flex-wrap items-end justify-end gap-6 border-t border-[#F9F8F6]/15 pt-8">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#8A9A86]">
            FabFathers · Purpose
          </p>
        </div>
      </div>
    </section>
  );
};
